import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { InputWithAlert } from "@/components/ui/input-with-alert";

export const CorrectionViewDetailsSection = ({ correctionDetails }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!correctionDetails) {
    return null;
  }

  const {
    originalInvoice,
    correctionReason,
    correctionSequence,
    originalInvoiceNumber,
    originalInvoiceDate,
  } = correctionDetails;

  return (
    <div className="w-full pb-6">
      <div className=" py-4 space-y-3">
        <div className="flex flex-wrap gap-4">
          <div className="flex-1 min-w-[200px]">
            <div className="grid grid-cols-2 items-center gap-4">
              <div>
                <InputWithAlert
                  label={t("invoices:original_invoice")}
                  value={originalInvoiceNumber}
                  readOnly={true}
                  disabled
                  inputClassName={"h-12 mt-2 mb-4 bg-white"}
                />
               
              </div>
              <div>
                <InputWithAlert
                  label={t("invoices:correction_reason")}
                  value={correctionReason}
                  readOnly={true}
                  disabled
                  inputClassName={"h-12 mt-2 mb-4 bg-white"}
                />
              </div>
            </div>
             {originalInvoice && (
                  <Button
                    variant="link"
                    className="text-blueText p-0 h-auto"
                    onClick={() =>
                      navigate(`/admin/invoices/details/${originalInvoice.id}`)
                    }
                  >
                    {t("common:button_view")}
                  </Button>
                )}
          </div>
        </div>
      </div>
    </div>
  );
};
